/*=========================================================================================
File Name: state.js
Description: Vuex Store - state
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
	var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
	var mq = function(query) {
		return window.matchMedia(query).matches;
	}
	
	if (('ontouchstart' in window) || window.DocumentTouch) {
		return true;
	}
	
	// include the 'heartz' as a way to have a non matching MQ to help terminate the join
	// https://git.io/vznFH
	var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return mq(query);
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
	bodyOverlay             : false,
	isVerticalNavMenuActive : true,
	is_touch_device         : is_touch_device(),
	mainLayoutType          : themeConfig.mainLayoutType || "vertical",
	navbarSearchAndPinList  : navbarSearchAndPinList,
	reduceButton            : themeConfig.sidebarCollapsed,
	verticalNavMenuWidth    : "reduced",
	verticalNavMenuItemsMin : false,
	scrollY                 : 0,
	starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
	theme                   : themeConfig.theme || "light",
	themePrimaryColor       : colors.primary,
	
	// Can be used to get current window with
	// Note: Above breakpoint state is for internal use of sidebar & navbar component
	windowWidth: null,


	// ////////////////////////////////////////////
	// CUSTOM VARIABLES
	// ////////////////////////////////////////////

	// Takedown Data
	takedownDomains: [],
	
	// Listing Count
	listingCount: {
		total: null,
		filtered: null
	},
	
	// CNIC Promo Filter
	promoFilter: null,

	// Table Filter
	tableFilter: {
		options: null,
		value: null,
		active: false,
	},

	// Blacklisted Keywords
	blacklistedKeywords: [],

	// Switch to tab on Promo Lists
	switchToTab: null,

	// NOTE: Master data
	countries: [],
	currencies: [],
	tlds: [],
	registrars: [],
	resellers: [],
	groups: [],
	promoTags: [],
	customTags: [],
	clientOptions: [],
	customUniqueRegistrars: [],
	tucowsOnboardingRegistrars: [],

	users: [],
	ams: [],
	roles: [],
	
	clientRebateStatus: null,
	clientToken: null,
	clientAMName: null,
	clientAMEmail: null,

	// Initialize from build-time env var (VUE_APP_DISABLE_CNIC).
	// This ensures the flag reflects the configured value at app startup
	// without relying on a dispatch timing.
	disableCNICFlag: (process.env.VUE_APP_DISABLE_CNIC && process.env.VUE_APP_DISABLE_CNIC.toLowerCase() === 'true') ? true : false
}

export default state
